import React from 'react';
import PropTypes from 'prop-types';

const WriteBoard = ({className = '', color = '#000'}) => {
  return (
    <svg
      className={`dib ${className}`}
      width="15"
      height="15"
      viewBox="0 0 15 15">
      <g fill={color}>
        <path d="M14.527.78H7.973V.474a.473.473 0 0 0-.946 0v.308H.473A.473.473 0 0 0 0 1.254v1.561c0 .262.212.474.473.474h.308v8.115c0 .261.212.473.473.473h5.3l-1.775 2.366a.473.473 0 1 0 .757.568l1.49-1.988v1.704a.473.473 0 0 0 .947 0v-1.704l1.49 1.988a.472.472 0 1 0 .758-.568l-1.775-2.366h5.3a.473.473 0 0 0 .473-.473V3.289h.308A.473.473 0 0 0 15 2.815V1.254a.473.473 0 0 0-.473-.473zM.947 2.343v-.615h13.107v.615H.946zm12.326 8.589H1.727V3.289h11.546v7.642z" />
        <path d="M3.596 7.192h7.027a.473.473 0 0 0 0-.946H3.596a.473.473 0 0 0 0 .946zM3.596 5.631h1.562a.473.473 0 1 0 0-.946H3.596a.473.473 0 0 0 0 .946zM3.596 8.754h4.685a.473.473 0 0 0 0-.946H3.596a.473.473 0 0 0 0 .946z" />
      </g>
    </svg>
  );
};

WriteBoard.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default WriteBoard;
